import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';
import { Customer } from '../classes/customer';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(private httpClient: HttpClient, private apiService: ApiService) { }

  public current(): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/current`);
  }

  public list(): Observable<any> {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/customers`);
  }

  public acceptTnC() {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/accept-tnc`, {})
  }

  public ping() {
    return this.httpClient.get(`${this.apiService.apiUrl()}/api/customer/ping`)
  }

  public verifyEmail(code: string): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/verify-email`, { code })
  }

  public resendEmailVerification(): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/verify-email/resend`, {})
  }

  public vatStatus(customer: Customer): Observable<any> {
    return this.httpClient.post(`${this.apiService.apiUrl()}/api/customer/public/${this.apiService.organizationId()}/vat-status`, { customer })
  }
}
